<div *ngIf="!hide" class="container"></div>
